import {FC} from 'react';
import FieldResult from '../FieldResult';

type FormResultProps = {
    className?: string;
    prefix?: string;
};
const FormResult: FC<FormResultProps> = ({className, prefix}) => (
    <>
        <FieldResult
            className={className}
            name={prefix ? `${prefix}NonFieldErrors` : 'nonFieldErrors'}
        />
        <FieldResult
            className={className}
            name={prefix ? `${prefix}SuccessMessage` : 'successMessage'}
        />
    </>
);

export default FormResult;
